/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_Player_CountInputs */



/**
* | output |
* | --- |
* | "Players who took part" |
*
* @param {Archival_Player_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_player_count = /** @type {((inputs?: Archival_Player_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_Player_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueurs ayant participé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugadores que participaron")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogadores que participaram")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatori che hanno partecipato")
	return /** @type {LocalizedString} */ ("Players who took part")
});